module.exports = __webpack_public_path__ + "3826ca63327bda60d6e401502ac366f4.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key-art-1080.webp.png
// module id = 425
// module chunks = 0